var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolidproof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 575,
    viewBox: "0 0 552 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0522 513.768C50.6842 512.296 48.1563 511.048 45.4683 510.024C42.8443 508.936 40.2843 508.104 37.7883 507.528C35.3563 506.888 33.2123 506.568 31.3563 506.568C29.2443 506.568 27.5483 506.984 26.2683 507.816C24.9883 508.584 24.3483 509.8 24.3483 511.464C24.3483 513.128 24.9563 514.504 26.1723 515.592C27.4523 516.616 29.1483 517.48 31.2603 518.184C33.3723 518.888 35.7083 519.592 38.2683 520.296C40.8283 521 43.3563 521.832 45.8523 522.792C48.3483 523.752 50.6523 525 52.7643 526.536C54.8763 528.008 56.5723 529.928 57.8523 532.296C59.1323 534.664 59.7723 537.608 59.7723 541.128C59.7723 545.672 58.5563 549.512 56.1243 552.648C53.6923 555.72 50.4283 558.056 46.3323 559.656C42.2363 561.192 37.6923 561.96 32.7003 561.96C28.9243 561.96 25.1483 561.544 21.3723 560.712C17.6603 559.816 14.1083 558.568 10.7163 556.968C7.38825 555.304 4.38025 553.352 1.69225 551.112L8.50825 537.576C10.8123 539.624 13.4043 541.416 16.2843 542.952C19.1643 544.488 22.0763 545.704 25.0203 546.6C27.9643 547.432 30.5883 547.848 32.8923 547.848C35.5163 547.848 37.5643 547.368 39.0363 546.408C40.5723 545.384 41.3403 543.912 41.3403 541.992C41.3403 540.328 40.7003 538.984 39.4203 537.96C38.1403 536.872 36.4443 535.976 34.3323 535.272C32.2203 534.568 29.8843 533.896 27.3243 533.256C24.8283 532.552 22.3003 531.752 19.7403 530.856C17.2443 529.896 14.9403 528.712 12.8282 527.304C10.7163 525.832 9.02025 523.944 7.74025 521.64C6.52425 519.336 5.91625 516.456 5.91625 513C5.91625 508.84 7.00425 505.224 9.18025 502.152C11.4203 499.016 14.5563 496.616 18.5883 494.952C22.6843 493.224 27.4203 492.36 32.7963 492.36C37.7243 492.36 42.5563 493.064 47.2923 494.472C52.0283 495.88 56.1562 497.704 59.6763 499.944L53.0522 513.768ZM100.811 492.648C106.059 492.648 110.859 493.512 115.211 495.24C119.627 496.968 123.467 499.4 126.731 502.536C130.059 505.672 132.619 509.352 134.411 513.576C136.267 517.736 137.195 522.28 137.195 527.208C137.195 532.2 136.267 536.84 134.411 541.128C132.619 545.352 130.059 549.064 126.731 552.264C123.467 555.4 119.627 557.864 115.211 559.656C110.859 561.384 106.059 562.248 100.811 562.248C95.6268 562.248 90.8268 561.384 86.4108 559.656C81.9948 557.864 78.1228 555.4 74.7948 552.264C71.5308 549.064 68.9708 545.352 67.1148 541.128C65.3228 536.84 64.4268 532.2 64.4268 527.208C64.4268 522.28 65.3228 517.704 67.1148 513.48C68.9708 509.256 71.5308 505.608 74.7948 502.536C78.1228 499.4 81.9948 496.968 86.4108 495.24C90.8268 493.512 95.6268 492.648 100.811 492.648ZM101.003 507.336C98.5068 507.336 96.1068 507.848 93.8028 508.872C91.5628 509.832 89.5788 511.24 87.8508 513.096C86.1868 514.888 84.8748 517 83.9148 519.432C82.9548 521.8 82.4748 524.424 82.4748 527.304C82.4748 530.12 82.9548 532.776 83.9148 535.272C84.8748 537.704 86.2188 539.848 87.9468 541.704C89.6748 543.496 91.6588 544.904 93.8988 545.928C96.1388 546.952 98.5068 547.464 101.003 547.464C103.499 547.464 105.835 546.952 108.011 545.928C110.251 544.904 112.203 543.496 113.867 541.704C115.531 539.848 116.811 537.704 117.707 535.272C118.667 532.776 119.147 530.12 119.147 527.304C119.147 524.424 118.667 521.8 117.707 519.432C116.811 517 115.531 514.888 113.867 513.096C112.203 511.24 110.251 509.832 108.011 508.872C105.835 507.848 103.499 507.336 101.003 507.336ZM145.903 493.704H163.471V546.216H191.983V561H145.903V493.704ZM199.997 493.704H217.565V561H199.997V493.704ZM259.645 493.704C264.957 493.704 269.789 494.536 274.141 496.2C278.557 497.8 282.333 500.104 285.469 503.112C288.669 506.056 291.133 509.576 292.861 513.672C294.589 517.768 295.453 522.312 295.453 527.304C295.453 532.36 294.557 536.936 292.765 541.032C291.037 545.128 288.573 548.68 285.373 551.688C282.173 554.696 278.333 557 273.853 558.6C269.373 560.2 264.413 561 258.973 561H230.653V493.704H259.645ZM260.125 546.984C262.685 546.984 265.021 546.536 267.133 545.64C269.245 544.68 271.069 543.336 272.605 541.608C274.205 539.88 275.421 537.832 276.253 535.464C277.085 533.032 277.501 530.376 277.501 527.496C277.501 524.552 277.053 521.896 276.157 519.528C275.261 517.096 273.981 515.016 272.317 513.288C270.717 511.496 268.797 510.152 266.557 509.256C264.381 508.296 261.949 507.816 259.261 507.816H248.221V546.984H260.125ZM333.049 493.8C341.369 493.8 347.801 495.784 352.345 499.752C356.953 503.656 359.257 509.16 359.257 516.264C359.257 523.624 356.953 529.352 352.345 533.448C347.801 537.48 341.369 539.496 333.049 539.496H312.121L315.481 536.136V561H307.801V493.8H333.049ZM332.761 532.872C338.841 532.872 343.545 531.496 346.873 528.744C350.201 525.928 351.865 521.832 351.865 516.456C351.865 511.208 350.201 507.24 346.873 504.552C343.545 501.864 338.841 500.52 332.761 500.52H312.121L315.481 497.16V536.232L312.121 532.872H332.761ZM396.596 517.128C392.82 517.064 389.556 517.864 386.804 519.528C384.116 521.128 382.036 523.4 380.564 526.344C379.092 529.224 378.356 532.616 378.356 536.52L375.764 536.232C375.764 530.728 376.596 526.056 378.26 522.216C379.924 518.376 382.324 515.432 385.46 513.384C388.596 511.336 392.308 510.312 396.596 510.312V517.128ZM370.964 510.504H378.452V561H370.964V510.504ZM427.227 510.312C432.219 510.312 436.635 511.4 440.475 513.576C444.379 515.688 447.419 518.664 449.595 522.504C451.771 526.344 452.859 530.76 452.859 535.752C452.859 540.744 451.771 545.16 449.595 549C447.419 552.84 444.379 555.848 440.475 558.024C436.635 560.136 432.219 561.192 427.227 561.192C422.235 561.192 417.787 560.136 413.883 558.024C410.043 555.848 407.035 552.84 404.859 549C402.683 545.16 401.595 540.744 401.595 535.752C401.595 530.76 402.683 526.344 404.859 522.504C407.035 518.664 410.043 515.688 413.883 513.576C417.787 511.4 422.235 510.312 427.227 510.312ZM427.227 516.552C423.707 516.552 420.571 517.384 417.819 519.048C415.067 520.648 412.923 522.888 411.387 525.768C409.851 528.648 409.083 531.976 409.083 535.752C409.083 539.592 409.851 542.984 411.387 545.928C412.923 548.808 415.067 551.08 417.819 552.744C420.571 554.344 423.707 555.144 427.227 555.144C430.811 555.144 433.947 554.344 436.635 552.744C439.387 551.08 441.531 548.808 443.067 545.928C444.603 542.984 445.371 539.592 445.371 535.752C445.371 531.976 444.603 528.648 443.067 525.768C441.531 522.888 439.387 520.648 436.635 519.048C433.947 517.384 430.811 516.552 427.227 516.552ZM486.57 510.312C491.562 510.312 495.978 511.4 499.818 513.576C503.722 515.688 506.762 518.664 508.938 522.504C511.114 526.344 512.202 530.76 512.202 535.752C512.202 540.744 511.114 545.16 508.938 549C506.762 552.84 503.722 555.848 499.818 558.024C495.978 560.136 491.562 561.192 486.57 561.192C481.578 561.192 477.13 560.136 473.226 558.024C469.386 555.848 466.378 552.84 464.202 549C462.026 545.16 460.938 540.744 460.938 535.752C460.938 530.76 462.026 526.344 464.202 522.504C466.378 518.664 469.386 515.688 473.226 513.576C477.13 511.4 481.578 510.312 486.57 510.312ZM486.57 516.552C483.05 516.552 479.914 517.384 477.162 519.048C474.41 520.648 472.266 522.888 470.73 525.768C469.194 528.648 468.426 531.976 468.426 535.752C468.426 539.592 469.194 542.984 470.73 545.928C472.266 548.808 474.41 551.08 477.162 552.744C479.914 554.344 483.05 555.144 486.57 555.144C490.154 555.144 493.29 554.344 495.978 552.744C498.73 551.08 500.874 548.808 502.41 545.928C503.946 542.984 504.714 539.592 504.714 535.752C504.714 531.976 503.946 528.648 502.41 525.768C500.874 522.888 498.73 520.648 495.978 519.048C493.29 517.384 490.154 516.552 486.57 516.552ZM526.625 505.896C526.625 502.248 527.361 499.176 528.833 496.68C530.369 494.184 532.385 492.296 534.881 491.016C537.377 489.672 540.001 489.032 542.753 489.096C544.225 489.096 545.697 489.32 547.169 489.768C548.705 490.152 550.113 490.696 551.393 491.4L549.569 497.16C548.609 496.712 547.553 496.328 546.401 496.008C545.313 495.624 544.161 495.432 542.945 495.432C541.345 495.432 539.841 495.816 538.433 496.584C537.089 497.288 536.001 498.376 535.169 499.848C534.401 501.256 534.017 502.984 534.017 505.032V561H526.625V505.896ZM520.097 512.04H548.513V517.608H520.097V512.04Z",
    fill: "#030930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.224 53.53C267.324 53.53 267.384 53.66 267.394 53.91C267.444 55.36 267.394 56.82 267.394 58.27V75.71L267.344 93.16V110.6L267.194 128L267.144 145.44V162.88V180.32L267.004 197.81V215.25V232.69V250.13L266.954 267.57V285.01L266.904 302.46L266.854 319.9V337.34V354.78L266.804 372.22L266.754 389.66V400.48C234.779 381.301 206.571 356.451 183.514 327.15C205.274 328.82 228.614 325.15 245.244 311.03C251.412 305.793 256.417 299.324 259.939 292.038C263.46 284.753 265.42 276.812 265.692 268.724C265.964 260.637 264.542 252.582 261.519 245.077C258.495 237.571 253.936 230.78 248.134 225.14C235.594 212.95 218.414 207.14 202.534 199.78C193.954 195.78 184.234 188.71 186.024 179.43C187.814 170.15 199.454 167.14 209.004 166.5C225.864 165.36 242.75 164.983 259.664 165.37L260.504 125.96C243.504 126.69 226.504 124.88 209.574 125.75C192.644 126.62 175.134 130.49 161.854 141.07C155.975 145.758 151.124 151.604 147.6 158.245C144.076 164.887 141.955 172.182 141.369 179.678C140.783 187.173 141.744 194.709 144.193 201.818C146.641 208.926 150.525 215.456 155.604 221C165.054 231.34 178.084 237.66 191.194 242.61C198.324 245.3 205.734 247.74 211.674 252.51C217.614 257.28 221.864 265.06 220.064 272.46C217.324 283.76 203.064 287.71 191.474 286.88C179.241 285.99 167.398 282.188 156.934 275.79C153.787 273.98 150.942 271.689 148.504 269C145.734 265.76 143.944 261.8 142.274 257.87C121.939 209.759 114.145 157.274 119.624 105.33C119.624 105.24 126.354 105.11 126.984 105.08C129.464 104.96 131.937 104.8 134.404 104.6C139.357 104.2 144.287 103.667 149.194 103C154.1 102.333 158.987 101.497 163.854 100.49C168.714 99.5033 173.544 98.3767 178.344 97.11C183.144 95.8433 187.897 94.4333 192.604 92.88C197.324 91.3333 201.99 89.6467 206.604 87.82C211.217 85.9933 215.774 84.0333 220.274 81.94C224.76 79.8467 229.19 77.6267 233.564 75.28C237.937 72.9333 242.23 70.45 246.444 67.83C250.664 65.2233 254.797 62.4867 258.844 59.62C260.844 58.19 262.844 56.72 264.844 55.23L266.334 54.11C266.604 53.88 267.004 53.46 267.224 53.53Z",
    fill: "#030930"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.484 6.4501C267.484 6.9101 267.484 7.3001 267.484 7.3001L267.424 21.3001V27.3501L267.334 27.4401C260.769 32.8955 253.905 37.9801 246.774 42.6701C176.874 88.7901 98.1736 87.7201 98.1736 87.7201C89.8436 174.84 110.584 243.72 140.084 295.95C145.084 304.82 150.354 313.19 155.754 321.11C179.236 355.294 208.309 385.277 241.754 409.8C243.534 411.087 245.237 412.297 246.864 413.43C253.131 417.921 259.655 422.041 266.404 425.77V427.71V444.36V449.68C266.404 449.68 52.7736 335.24 78.0836 71.0801C78.0836 71.0801 184.654 72.5301 267.504 3.6001L267.484 6.4501Z",
    fill: "#030930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M430.464 284.07C430.884 283.23 431.314 282.4 431.714 281.56H430.434L430.464 284.07Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M417.643 303.58H419.973C421.66 300.647 423.327 297.673 424.973 294.66L417.563 294.74L417.643 303.58Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M413.526 307.788L404.666 307.879L404.757 316.738L413.617 316.647L413.526 307.788Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400.642 320.94L391.782 321.031L391.873 329.89L400.733 329.799L400.642 320.94Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387.758 334.091L378.898 334.183L378.989 343.042L387.849 342.951L387.758 334.091Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M374.884 347.24L367.884 347.31C367.264 348.05 366.634 348.77 366.014 349.5L366.084 356.19L374.944 356.09L374.884 347.24Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M362.004 360.39L356.274 360.45L353.184 363.74L353.234 369.34L362.094 369.24L362.004 360.39Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M349.104 373.54L343.444 373.6L340.284 376.6L340.344 382.44L349.204 382.34L349.104 373.54Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M336.224 386.69L329.264 386.76L327.384 388.4L327.464 395.64L336.314 395.55L336.224 386.69Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M323.348 399.841L314.489 399.933L314.58 408.792L323.44 408.701L323.348 399.841Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M310.464 413.003L301.605 413.094L301.696 421.954L310.556 421.863L310.464 413.003Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M297.57 426.145L288.711 426.237L288.802 435.096L297.662 435.005L297.57 426.145Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.914 439.38V448.24H278.334C279.644 447.51 281.824 446.24 284.754 444.44L284.694 439.32L276.914 439.38Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M443.074 251.32H445.074C446.224 248.32 447.364 245.32 448.464 242.27L443.014 242.33L443.074 251.32Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M439.094 255.367L430.085 255.46L430.178 264.469L439.187 264.377L439.094 255.367Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M426.211 268.529L417.201 268.622L417.294 277.631L426.303 277.539L426.211 268.529Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M412.004 281.69C410.404 284.757 408.777 287.773 407.124 290.74L413.424 290.68L413.324 281.68L412.004 281.69Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M400.544 303.83V302.08C400.194 302.67 399.834 303.25 399.464 303.84L400.544 303.83Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M352.794 334.37V335.63C353.164 335.21 353.544 334.79 353.904 334.36L352.794 334.37Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M339.914 347.52V349.52C340.574 348.85 341.224 348.18 341.914 347.52H339.914Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M327.004 360.67V362L328.434 360.69L327.004 360.67Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M281.354 422.23H284.594V420.33C283.374 421 282.294 421.68 281.354 422.23Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M455.604 212.21H457.864C458.677 209.17 459.46 206.107 460.214 203.02H455.514L455.604 212.21Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M451.779 216.109L442.62 216.203L442.714 225.362L451.874 225.268L451.779 216.109Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M433.884 229.3C432.884 232.407 431.847 235.473 430.774 238.5L438.994 238.42L438.904 229.25L433.884 229.3Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M426.104 250.89C426.024 251.13 425.924 251.35 425.844 251.57H426.113L426.104 250.89Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M397.664 268.74L391.094 268.81L391.184 277.96H392.924C394.544 274.947 396.124 271.873 397.664 268.74Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M387.434 287.7L387.374 281.86L378.214 281.96L378.304 291.12L385.444 291.05L387.434 287.7Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M374.476 295.02L365.317 295.115L365.411 304.274L374.57 304.18L374.476 295.02Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M361.602 308.162L352.443 308.257L352.537 317.416L361.696 317.322L361.602 308.162Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M348.718 321.334L339.559 321.428L339.653 330.588L348.813 330.494L348.718 321.334Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M335.825 334.476L326.665 334.571L326.759 343.73L335.919 343.636L335.825 334.476Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M322.951 347.628L313.791 347.722L313.885 356.882L323.045 356.788L322.951 347.628Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M309.972 360.869L300.812 360.96L300.903 370.12L310.063 370.029L309.972 360.869Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M297.173 373.932L288.013 374.026L288.108 383.186L297.267 383.092L297.173 373.932Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M284.384 394.73L284.314 387.08L276.954 387.15V396.32L281.894 396.27L284.384 394.73Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M455.174 176.93L455.264 186.25L463.894 186.16C464.114 185.04 464.334 183.92 464.534 182.78L464.474 176.84L455.174 176.93Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M451.594 190L444.004 190.08C443.484 192.73 442.934 195.35 442.364 197.96V199.41L451.684 199.31L451.594 190Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M416.514 216.39V220.14C416.884 218.9 417.234 217.64 417.584 216.38L416.514 216.39Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M413.004 231.6V229.45L403.684 229.54L403.784 238.86L410.514 238.79C411.334 236.42 412.164 234 413.004 231.6Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M400.055 242.61L390.746 242.706L390.841 252.015L400.151 251.919L400.055 242.61Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M387.171 255.752L377.862 255.848L377.957 265.157L387.267 265.061L387.171 255.752Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M374.287 268.914L364.978 269.01L365.074 278.319L374.383 278.223L374.287 268.914Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M361.413 282.055L352.104 282.151L352.2 291.461L361.509 291.365L361.413 282.055Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M348.519 295.208L339.21 295.303L339.306 304.613L348.615 304.517L348.519 295.208Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M335.646 308.369L326.336 308.465L326.432 317.775L335.742 317.679L335.646 308.369Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M322.854 330.82L313.544 330.92L313.464 323.19L322.784 323.24L322.854 330.82Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M309.868 334.673L300.558 334.769L300.654 344.079L309.964 343.983L309.868 334.673Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M296.984 347.816L287.674 347.911L287.77 357.221L297.08 357.125L296.984 347.816Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M284.114 360.96L276.984 361.04L276.974 370.35L284.204 370.28L284.114 360.96Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M467.804 147.14H469.524C469.834 144.01 470.084 140.85 470.324 137.66H467.704L467.804 147.14Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M464.286 150.733L454.826 150.831L454.924 160.29L464.383 160.193L464.286 150.733Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M448.113 163.92C447.727 167.1 447.307 170.257 446.854 173.39H451.504L451.404 163.93L448.113 163.92Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M423.604 190.21L416.174 190.28L416.274 199.75L421.714 199.69C422.394 196.563 423.024 193.403 423.604 190.21Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M412.854 212.8L407.004 212.86C408.134 209.769 409.027 206.597 409.674 203.37H412.754L412.854 212.8Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M374.204 252.26L364.734 252.35V250.6C367.95 249.604 371.099 248.405 374.164 247.01L374.204 252.26Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M361.214 255.949L351.755 256.046L351.852 265.506L361.312 265.408L361.214 255.949Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M348.265 269.196L338.805 269.291L338.9 278.751L348.36 278.656L348.265 269.196Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M335.447 282.253L325.987 282.35L326.085 291.81L335.544 291.712L335.447 282.253Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M296.904 331.16L287.434 331.26L287.364 323.05L296.824 323.1L296.904 331.16Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M283.924 334.85L277.004 334.92L276.994 344.39L284.014 344.31L283.924 334.85Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M467.464 121.17H471.164C471.27 117.983 471.337 114.777 471.364 111.55H467.364L467.464 121.17Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M464.087 124.627L454.467 124.726L454.566 134.335L464.186 134.236L464.087 124.627Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M450.274 137.78C450.127 141.02 449.934 144.227 449.694 147.4H451.304L451.204 137.78H450.274Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M425.445 164.073L415.826 164.172L415.925 173.791L425.544 173.692L425.445 164.073Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M412.654 186.84H411.164C411.134 183.625 410.874 180.417 410.384 177.24H412.554L412.654 186.84Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M335.354 265.75L325.954 265.85L326.004 256.23L335.254 256.13L335.354 265.75Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M281.244 308.77L281.194 318.39L277.014 318.43L277.024 308.81L281.244 308.77Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M470.854 85.4199H467.014L467.114 95.1799H471.214C471.134 91.9999 471.004 88.6999 470.854 85.4199Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M463.898 98.52L454.128 98.6206L454.229 108.39L463.999 108.289L463.898 98.52Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M450.624 111.66C450.684 114.94 450.71 118.197 450.704 121.43H451.114L451.014 111.67L450.624 111.66Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M425.246 137.966L415.477 138.066L415.577 147.836L425.347 147.735L425.246 137.966Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M412.474 160.88L405.554 160.95C404.691 159.075 403.72 157.252 402.644 155.49V151.22L412.404 151.12L412.474 160.88Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M366.624 190.64C366.514 194.004 365.8 197.32 364.514 200.43H364.054L363.954 190.66L366.624 190.64Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M360.863 206.16C358.194 209.017 354.863 211.173 351.163 212.44L351.063 203.82L360.833 203.72L360.863 206.16Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M281.384 282.65L281.324 292.42L277.034 292.47L277.044 282.7L281.384 282.65Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M463.699 72.3935L453.78 72.4956L453.882 82.4151L463.801 82.3129L463.699 72.3935Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M449.264 85.56C449.544 88.8934 449.78 92.1967 449.974 95.47H450.974L450.864 85.55L449.264 85.56Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M425.047 111.859L415.128 111.961L415.23 121.881L425.15 121.779L425.047 111.859Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M412.154 125.108L402.234 125.207L402.333 135.127L412.253 135.028L412.154 125.108Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M399.394 148.07H397.214C395.724 146.367 394.124 144.763 392.424 143.27C391.424 142.39 390.424 141.54 389.424 140.73V138.24L399.334 138.13L399.394 148.07Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M360.638 177.619L350.719 177.721L350.821 187.641L360.74 187.539L360.638 177.619Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M347.712 190.852L337.792 190.951L337.891 200.871L347.811 200.772L347.712 190.852Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M334.87 203.913L324.951 204.015L325.053 213.935L334.972 213.832L334.87 203.913Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M281.514 256.54L281.464 266.46L277.054 266.5L277.064 256.58L281.514 256.54Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M450.674 64.1599C447.624 63.8999 444.254 63.5499 440.604 63.1599L440.664 69.6599L450.734 69.5599L450.674 64.1599Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M437.744 72.5801L427.674 72.6901L427.754 80.6701L437.834 81.5301L437.744 72.5801Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M412.004 99.0001L410.554 98.8701L401.904 99.0001L402.014 109.06L412.084 108.96L412.004 99.0001Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M399.091 112.047L389.021 112.15L389.125 122.22L399.194 122.116L399.091 112.047Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M386.314 135.26L380.984 135.31C379.454 134.49 377.874 133.72 376.224 133.02L376.144 125.3L386.214 125.19L386.314 135.26Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M347.584 166.47L347.664 174.72L337.594 174.82L337.504 165.6L347.584 166.47Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M334.681 177.806L324.612 177.91L324.716 187.98L334.785 187.876L334.681 177.806Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M321.787 190.948L311.718 191.052L311.821 201.121L321.891 201.018L321.787 190.948Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M308.903 204.11L298.834 204.214L298.938 214.284L309.007 214.18L308.903 204.11Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M281.653 230.42L281.604 240.49L277.083 240.54V230.47L281.653 230.42Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M424.774 69.8399L424.674 60.81L418.324 59.7L414.454 59.7299L414.554 69.9499L424.774 69.8399Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M411.783 72.78L401.563 72.89V76.77C405.123 77.46 408.563 78.05 411.803 78.57L411.783 72.78Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M388.774 95.8701V96.2601H390.774L388.774 95.8701Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M386.018 99.0818L375.798 99.187L375.904 109.406L386.123 109.301L386.018 99.0818Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M373.124 112.244L362.905 112.349L363.01 122.569L373.229 122.463L373.124 112.244Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M360.284 128.08C357.014 127.41 353.594 126.88 350.034 126.51V125.51L360.264 125.4L360.284 128.08Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M321.704 175.06L311.484 175.17L311.384 165.42L321.604 165.44L321.704 175.06Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M308.715 177.994L298.495 178.099L298.6 188.318L308.82 188.213L308.715 177.994Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M295.821 191.156L285.601 191.261L285.707 201.48L295.926 201.375L295.821 191.156Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M282.954 204.29L277.104 204.35L277.094 214.58L283.064 214.52L282.954 204.29Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M405.683 57.1001L401.313 56.1001V57.1001H405.683Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M398.703 59.8234L388.333 59.9302L388.44 70.2996L398.81 70.1928L398.703 59.8234Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M384.434 73L385.834 73.35V73H384.434Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M362.684 96.6001L373.004 96.4901V92.5501C369.634 91.7401 366.154 90.8301 362.614 89.8201L362.684 96.6001Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M360.061 99.2792L349.692 99.386L349.799 109.755L360.168 109.649L360.061 99.2792Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M347.168 112.431L336.798 112.538L336.905 122.908L347.274 122.801L347.168 112.431Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M334.294 125.58V125.77L323.914 125.71V125.68L334.294 125.58Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M295.744 175.41L285.374 175.51L285.274 165.39L295.654 165.41L295.744 175.41Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M282.754 178.18L277.124 178.24V188.62L282.864 188.56L282.754 178.18Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M385.744 57.38L385.684 52C382.21 51.0134 378.69 49.9434 375.124 48.79L375.214 57.48L385.744 57.38Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M362.224 60.11L362.294 66.56L372.854 69.85L372.754 60.01L362.224 60.11Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M346.989 86.3244L336.459 86.4329L336.568 96.9623L347.097 96.8539L346.989 86.3244Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M334.095 99.4765L323.565 99.585L323.674 110.114L334.203 110.006L334.095 99.4765Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M321.221 112.618L310.691 112.727L310.8 123.256L321.329 123.148L321.221 112.618Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M282.064 152.08L282.004 162.6L277.144 162.65L277.154 152.13L282.064 152.08Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M363.114 44.67L362.004 44.26V44.69L363.114 44.67Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M359.674 47.0558L348.994 47.1658L349.104 57.8452L359.784 57.7352L359.674 47.0558Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M345.004 60.22L346.804 60.9399V60.2L345.004 60.22Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M323.344 84.1401L334.004 84.0001V79.8501C330.454 78.3701 326.864 76.7801 323.274 75.0801L323.344 84.1401Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M321.022 86.5119L310.343 86.6218L310.453 97.3013L321.132 97.1913L321.022 86.5119Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M308.138 99.6637L297.458 99.7737L297.568 110.453L308.248 110.343L308.138 99.6637Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M295.254 112.806L284.575 112.916L284.685 123.595L295.364 123.485L295.254 112.806Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M282.204 125.95L282.144 136.64L277.164 136.69L277.174 126.01L282.204 125.95Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M346.704 44.9099L346.634 38.1499C343.704 36.8899 340.744 35.5599 337.784 34.1499H335.784L335.884 44.9999L346.704 44.9099Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M322.884 47.35V50.15C326.51 52.0233 330.137 53.7767 333.764 55.41L333.684 47.24L322.884 47.35Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M310.113 71.34L315.543 71.28C313.723 70.3267 311.903 69.3267 310.083 68.28L310.113 71.34Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M307.94 73.62L297.11 73.7283L297.218 84.5583L308.048 84.45L307.94 73.62Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M295.065 86.699L284.236 86.8105L284.347 97.64L295.177 97.5285L295.065 86.699Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M282.174 99.8501L277.194 99.9001L277.184 110.73L282.284 110.68L282.174 99.8501Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M333.454 32.1101C329.834 30.3634 326.214 28.51 322.594 26.55L322.654 32.2201L333.454 32.1101Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M290.664 7.09007L283.194 7.16007V3.32007C285.687 4.62007 288.177 5.87674 290.664 7.09007Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M309.654 34.39L309.744 42.94L313.904 45.33L320.744 45.26L320.634 34.28L309.654 34.39Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M294.866 60.5925L283.887 60.7056L284 71.685L294.979 71.5719L294.866 60.5925Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M281.984 73.74L277.214 73.79L277.204 84.77L282.104 84.71L281.984 73.74Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M310.094 19.41L309.424 19V19.41H310.094Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M307.552 21.3239L296.422 21.4385L296.537 32.5679L307.666 32.4533L307.552 21.3239Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M281.804 49.5299C281.034 48.9099 280.244 48.2899 279.474 47.6499H277.234V58.8099L281.914 58.7599L281.804 49.5299Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M294.594 19.6501L294.494 9.19012L293.334 8.37012L283.194 8.48012L283.314 19.7601L294.594 19.6501Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M405.004 327.57C406.504 325.36 408.004 323.12 409.454 320.85H404.934L405.004 327.57Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M392.104 342.9H394.104C396.284 339.99 398.434 337.01 400.584 333.98L392.004 334L392.104 342.9Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M379.134 347.2L379.224 356.05L383.874 356C385.254 354.29 386.644 352.55 388.024 350.79V347.1L379.134 347.2Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M366.244 360.35L366.334 369.2L372.744 369.13C373.554 368.22 374.354 367.31 375.164 366.38L375.104 360.25L366.244 360.35Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M362.214 373.412L353.354 373.504L353.446 382.363L362.305 382.272L362.214 373.412Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M349.33 386.565L340.47 386.656L340.562 395.515L349.421 395.424L349.33 386.565Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M336.446 399.716L327.587 399.808L327.678 408.667L336.537 408.576L336.446 399.716Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M314.714 413L314.804 421.85H316.964C319.114 420.16 321.334 418.38 323.604 416.53V412.93L314.714 413Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M301.833 426.11L301.903 433.03C304.653 431.08 307.593 428.94 310.693 426.61V426L301.833 426.11Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M289.004 441.77C290.23 440.983 291.534 440.133 292.914 439.22H288.984L289.004 441.77Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M443.204 255.91L443.454 255.32H443.204V255.91Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M430.414 277.49H433.704C435.137 274.523 436.534 271.503 437.894 268.43L430.324 268.51L430.414 277.49Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M426.445 281.536L417.435 281.629L417.528 290.638L426.537 290.545L426.445 281.536Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M413.551 294.688L404.541 294.781L404.634 303.79L413.643 303.697L413.551 294.688Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M400.674 307.84H396.924C395.214 310.53 393.484 313.16 391.744 315.76V316.9L400.744 316.81L400.674 307.84Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M387.884 330L387.794 321.55C385.744 324.45 383.694 327.29 381.614 330.06L387.884 330Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M371.333 343.19H374.993V338.74C373.743 340.23 372.543 341.72 371.333 343.19Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M360.004 356.33H362.084V354.04C361.414 354.79 360.724 355.57 360.004 356.33Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M349.234 369.46V367.83C348.694 368.38 348.164 368.93 347.624 369.47L349.234 369.46Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M333.874 382.63H336.354V380.38L333.874 382.63Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M318.614 395.81L323.474 395.76V391.76C321.804 393.18 320.184 394.52 318.614 395.81Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M310.524 402.24C307.53 404.527 304.697 406.643 302.024 408.59C301.874 408.7 301.724 408.81 301.574 408.9V409L310.574 408.91L310.524 402.24Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M297.604 413.05H295.604C293.054 414.8 290.704 416.36 288.604 417.7L288.654 422.13L297.654 422.04L297.604 413.05Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M276.934 426.29L276.914 435.29L284.814 435.21L284.724 426.2L276.934 426.29Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M455.774 219.65C456.127 218.45 456.46 217.25 456.774 216.05H455.714L455.774 219.65Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M442.854 229.21L442.944 238.37L449.824 238.3C450.574 236.13 451.314 233.93 452.044 231.72V229.12L442.854 229.21Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M439.119 242.288L429.96 242.382L430.054 251.541L439.214 251.447L439.119 242.288Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M420.264 264.64L426.334 264.58L426.244 255.43H424.244C422.957 258.557 421.63 261.627 420.264 264.64Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M378.434 295L378.504 302C380.044 299.67 381.574 297.32 383.074 294.9L378.434 295Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M374.424 308L365.554 308.09L365.644 317.26H367.724C370.004 314.27 372.214 311.2 374.424 308Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M361.874 324.81V321.18L352.714 321.27L352.804 330.44L357.334 330.39C358.834 328.57 360.347 326.71 361.874 324.81Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M348.932 334.341L339.773 334.436L339.867 343.595L349.027 343.501L348.932 334.341Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M336.124 353.35L336.064 347.49L326.904 347.58L327.004 356.74L332.694 356.68C333.824 355.59 335.004 354.48 336.124 353.35Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M323.224 365.39L323.174 360.64L314.024 360.73L314.114 369.89H318.114C319.764 368.43 321.484 366.94 323.224 365.39Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M310.294 373.79L301.144 373.89L301.234 383.05H301.464C304.254 380.99 307.224 378.72 310.324 376.25L310.294 373.79Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M288.254 387L288.304 392.18C290.604 390.68 293.204 388.93 296.054 386.92L288.254 387Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M455.493 199.26L461.104 199.2C461.824 196.12 462.49 193.01 463.104 189.87L455.354 189.95L455.493 199.26Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M451.805 203.019L442.495 203.115L442.591 212.424L451.9 212.328L451.805 203.019Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M439.004 225.47L438.904 216.16H437.794C436.92 219.307 436.007 222.42 435.054 225.5L439.004 225.47Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M409.083 242.51L403.854 242.56L403.954 251.87H405.363C406.643 248.8 407.893 245.67 409.083 242.51Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M400.279 255.627L390.969 255.723L391.065 265.032L400.375 264.936L400.279 255.627Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M387.405 268.779L378.096 268.875L378.192 278.184L387.501 278.088L387.405 268.779Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M374.511 281.931L365.202 282.027L365.298 291.336L374.607 291.24L374.511 281.931Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M361.627 295.073L352.318 295.168L352.414 304.478L361.723 304.382L361.627 295.073Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M348.744 308.234L339.434 308.33L339.53 317.64L348.839 317.544L348.744 308.234Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M335.778 321.471L326.468 321.564L326.561 330.874L335.871 330.781L335.778 321.471Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M322.986 334.529L313.676 334.625L313.772 343.934L323.082 343.838L322.986 334.529Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M310.092 347.691L300.782 347.786L300.878 357.096L310.188 357L310.092 347.691Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M297.208 360.843L287.898 360.938L287.994 370.248L297.304 370.152L297.208 360.843Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M284.334 373.98L276.964 374.06V383.37L284.434 383.29L284.334 373.98Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M468.004 160.15H468.064C468.464 157.02 468.834 153.86 469.154 150.67H467.904L468.004 160.15Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5 163.75L455.04 163.848L455.137 173.307L464.597 173.21L464.5 163.75Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M444.694 186.44L451.694 186.36L451.594 176.9H446.284C445.804 180.133 445.274 183.313 444.694 186.44Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M420.924 203.25L416.404 203.3L416.494 212.76H418.604C419.424 209.627 420.197 206.457 420.924 203.25Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M413.074 225.82L403.614 225.92L403.554 220.5C404.274 219.167 404.94 217.81 405.554 216.43L412.974 216.35L413.074 225.82Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M400.194 239L390.724 239.09V236.45C392.057 235.303 393.307 234.103 394.474 232.85C395.514 231.79 396.514 230.693 397.474 229.56H400.144L400.194 239Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M387.304 252.12L377.844 252.21L377.774 245.21C379.284 244.42 380.774 243.57 382.194 242.68L387.194 242.63L387.304 252.12Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M374.252 255.926L364.792 256.021L364.887 265.481L374.347 265.386L374.252 255.926Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M361.438 268.966L351.979 269.063L352.076 278.523L361.536 278.426L361.438 268.966Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M348.545 282.118L339.085 282.215L339.183 291.675L348.642 291.577L348.545 282.118Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M335.671 295.27L326.211 295.367L326.309 304.827L335.768 304.73L335.671 295.27Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M310.004 331.03L300.544 331.13L300.464 323.12L309.924 323.17L310.004 331.03Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M296.921 334.809L287.461 334.904L287.556 344.364L297.016 344.269L296.921 334.809Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M284.144 347.88L276.984 347.95L276.974 357.4L284.244 357.33L284.144 347.88Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M467.684 134.2H470.553C470.753 131.02 470.913 127.81 471.053 124.58H467.583L467.684 134.2Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M464.321 137.634L454.701 137.733L454.8 147.342L464.42 147.243L464.321 137.634Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M448.504 160.43H451.504L451.414 150.82H449.414C449.14 154.053 448.837 157.257 448.504 160.43Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M425.664 177.26V177.09L416.054 177.19L416.154 186.8L424.214 186.72C424.74 183.573 425.224 180.42 425.664 177.26Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M412.884 199.86H410.284C410.762 196.674 411.043 193.461 411.124 190.24H412.784L412.884 199.86Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M361.344 252.46H357.754C358.964 252.19 360.164 251.89 361.334 251.56L361.344 252.46Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M348.366 256.011L338.746 256.11L338.845 265.73L348.465 265.631L348.366 256.011Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M284.054 331.38L277.004 331.45V321.83L281.174 321.79L281.164 323.02L283.974 323.04L284.054 331.38Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M471.294 98.4299H467.234L467.344 108.2H471.344C471.394 105 471.364 101.71 471.294 98.4299Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M464.122 111.527L454.352 111.628L454.453 121.397L464.222 121.297L464.122 111.527Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M450.424 134.45H451.344L451.244 124.68H450.674C450.624 128 450.544 131.22 450.424 134.45Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M425.47 150.983L415.701 151.083L415.801 160.853L425.571 160.752L425.47 150.983Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M412.684 173.9H409.794C409.119 170.578 408.162 167.319 406.934 164.16L412.584 164.1L412.684 173.9Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M281.314 295.68L281.264 305.44L277.024 305.49L277.034 295.72L281.314 295.68Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M470.004 72.3301H466.884L466.994 82.2501H470.674C470.5 78.9634 470.277 75.6567 470.004 72.3301Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M463.928 85.5302L454.008 85.6294L454.108 95.5494L464.028 95.4502L463.928 85.5302Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M450.544 108.49H451.154L451.054 98.5701H450.144C450.324 101.91 450.454 105.21 450.544 108.49Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M425.281 124.876L415.362 124.978L415.464 134.898L425.383 134.796L425.281 124.876Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M412.398 138.018L402.478 138.12L402.58 148.04L412.5 147.938L412.398 138.018Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M366.654 187.46H363.934L363.824 177.54H364.304C365.801 180.636 366.603 184.022 366.654 187.46Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M360.82 190.731L350.9 190.83L351 200.75L360.92 200.651L360.82 190.731Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M348.083 213.69H346.753L338.163 213.78L338.063 203.86L347.983 203.76L348.073 213.37L348.083 213.69Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M281.444 269.56L281.394 279.48L277.044 279.52L277.054 269.61L281.444 269.56Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M463.794 64.9999C461.214 64.9099 457.794 64.7299 453.724 64.3999V69.4599L463.784 69.3599L463.794 64.9999Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M448.944 82C448.944 82.19 448.944 82.39 448.994 82.58H450.994L450.894 72.51L440.824 72.61L440.924 81.77C446.054 82 448.944 82 448.944 82Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M425.094 99.83C423.094 99.83 419.624 99.65 415.014 99.29L415.114 108.93L425.194 108.82L425.094 99.83Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M412.199 111.912L402.129 112.015L402.233 122.085L412.302 121.981L412.199 111.912Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M399.315 125.064L389.245 125.167L389.349 135.237L399.419 135.133L399.315 125.064Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M386.444 138.6L385.874 138.22H386.434L386.444 138.6Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M360.754 172.72L360.774 174.58L350.704 174.69L350.624 167.18L360.754 172.72Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M347.779 177.671L337.71 177.775L337.813 187.845L347.883 187.741L347.779 177.671Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M334.895 190.823L324.826 190.927L324.93 200.996L334.999 200.893L334.895 190.823Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M322.021 203.975L311.952 204.079L312.056 214.149L322.125 214.045L322.021 203.975Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M281.584 243.45L281.534 253.52L277.064 253.56L277.074 243.49L281.584 243.45Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M437.884 69.71L437.814 62.76C434.594 62.36 431.164 61.86 427.574 61.29L427.664 69.81L437.884 69.71Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M414.734 78.9999C418.394 79.5399 421.814 79.9999 424.974 80.3499L424.894 72.6299L414.674 72.7399L414.734 78.9999Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M399.116 98.957L388.896 99.0623L389.002 109.282L399.221 109.176L399.116 98.957Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M386.225 112.197L376.005 112.299L376.107 122.519L386.327 122.417L386.225 112.197Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M373.424 131.87C370.082 130.59 366.657 129.538 363.174 128.72V125.35L373.394 125.25L373.424 131.87Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M334.814 174.93L324.594 175.03L324.494 165.44L334.724 165.45L334.814 174.93Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M321.822 177.859L311.603 177.964L311.708 188.184L321.928 188.078L321.822 177.859Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M308.939 191.011L298.719 191.116L298.824 201.335L309.044 201.23L308.939 191.011Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M296.055 204.163L285.835 204.268L285.94 214.487L296.16 214.382L296.055 204.163Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M281.723 217.32L281.663 227.54L277.083 227.6L277.093 217.38L281.723 217.32Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M411.811 59.6984L401.441 59.8052L401.548 70.1746L411.918 70.0678L411.811 59.6984Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M388.574 74.0001C392.14 74.8468 395.607 75.6034 398.974 76.2701V72.8501L388.604 72.9601L388.574 74.0001Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M375.784 96.4599L386.164 96.3599V95.3599C382.824 94.7199 379.344 93.9899 375.764 93.1699L375.784 96.4599Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M373.159 99.1442L362.79 99.251L362.897 109.62L373.266 109.514L373.159 99.1442Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M360.275 112.286L349.906 112.393L350.013 122.763L360.382 122.656L360.275 112.286Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M347.414 126.26C344.074 125.98 340.614 125.81 337.034 125.79V125.55L347.404 125.44L347.414 126.26Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M308.854 175.27L298.484 175.38L298.384 165.4L308.754 165.42L308.854 175.27Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M295.856 178.056L285.486 178.163L285.593 188.532L295.963 188.426L295.856 178.056Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M282.984 191.2L277.124 191.26L277.114 201.63L283.094 201.57L282.984 191.2Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M398.844 57.24V55.5C395.404 54.66 391.887 53.74 388.294 52.74L388.344 57.35L398.844 57.24Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M385.854 59.8857L375.325 59.9941L375.433 70.5236L385.963 70.4152L385.854 59.8857Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M349.563 86.29L349.673 96.81L360.193 96.71L360.123 89.11C357.123 88.23 354.123 87.29 351.123 86.27L349.563 86.29Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M347.203 99.3315L336.673 99.4399L336.782 109.969L347.311 109.861L347.203 99.3315Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M334.329 112.493L323.799 112.602L323.908 123.131L334.437 123.023L334.329 112.493Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M321.444 125.63V125.7L317.134 125.68L321.444 125.63Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M282.894 175.62L277.134 175.68L277.144 165.14L281.994 165.09L282.784 165.08L282.794 165.39L282.894 175.62Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M362.204 57.7L372.894 57.59L372.794 48.04L369.564 46.95L362.094 47.0299L362.204 57.7Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M349.234 61.8901C352.847 63.2967 356.437 64.5934 360.004 65.7801L359.954 60.0701L349.264 60.1801L349.234 61.8901Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M336.444 83.9999L344.334 83.9199C341.714 82.9733 339.074 81.9733 336.414 80.9199L336.444 83.9999Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M334.13 86.3668L323.45 86.4768L323.56 97.1562L334.24 97.0463L334.13 86.3668Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M321.246 99.5287L310.567 99.6387L310.677 110.318L321.356 110.208L321.246 99.5287Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M308.362 112.681L297.683 112.791L297.793 123.47L308.472 123.36L308.362 112.681Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M282.134 138.98L282.074 149.66L277.154 149.72L277.164 139.03L282.134 138.98Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M359.814 44.7801V43.4501C356.224 42.0901 352.594 40.6601 348.944 39.1201L349.004 44.8901L359.814 44.7801Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M336.084 56.4401L339.674 58.0101L346.934 57.9301L346.814 47.1001L335.994 47.2201L336.084 56.4401Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M310.224 73.5199L310.334 84.3499L321.164 84.2399L321.064 74.0499L319.774 73.4199L310.224 73.5199Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M308.163 86.5643L297.334 86.6758L297.445 97.5052L308.275 97.3937L308.163 86.5643Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M295.289 99.7161L284.46 99.8276L284.571 110.657L295.401 110.546L295.289 99.7161Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M282.404 112.87L277.184 112.92L277.174 123.75L282.514 123.69L282.404 112.87Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M333.732 34.1535L322.753 34.2666L322.866 45.246L333.845 45.133L333.732 34.1535Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M320.874 49.11V47.29H317.534C318.634 47.94 319.754 48.53 320.874 49.11Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M297.004 60.5701L297.114 71.5701L308.114 71.4601V67.2201C304.474 65.1401 300.854 62.9401 297.254 60.5901L297.004 60.5701Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M295.08 73.6096L284.101 73.7227L284.214 84.7021L295.194 84.589L295.08 73.6096Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M282.214 86.75L277.214 86.81L277.194 97.78L282.324 97.73L282.214 86.75Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M309.644 32.43L320.784 32.31L320.714 25.53L313.214 21.27L309.534 21.3L309.644 32.43Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M296.654 34.6901L298.174 35.6901C301.387 37.8234 304.617 39.8567 307.864 41.7901L307.784 34.3101L296.654 34.4301V34.6901Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M283.884 58.7401L294.274 58.6301C290.754 56.2601 287.274 53.7401 283.804 51.0801L283.884 58.7401Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M282.014 60.6399L277.234 60.6899L277.224 71.8299L282.124 71.7799L282.014 60.6399Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M307.704 19.51V17.93C303.89 15.57 300.104 13.0833 296.344 10.47L296.434 19.63L307.704 19.51Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M283.454 25.0999C286.847 27.7666 290.264 30.2899 293.704 32.6699H294.824L294.704 21.3899L283.414 21.4999L283.454 25.0999Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M281.684 10.03L277.234 10.08V0L281.594 2.29L281.684 10.03Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M281.904 23H280.784C279.604 22.17 278.414 21.33 277.234 20.47V11.81L281.784 11.76L281.904 23Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M348.074 213.39C347.684 213.51 347.314 213.61 346.914 213.71H348.084L348.074 213.39ZM282.784 165.08H282.004V165.37H282.804L282.784 165.08Z",
    fill: "#030930",
    fillOpacity: 0.7
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M335.584 278.77L325.974 278.86L325.914 273.58L325.874 269.25H325.944L335.484 269.15L335.584 278.77Z",
    fill: "#030930",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidproof);
export default __webpack_public_path__ + "static/media/solidproof.c85a0cf188aa95541767c76c148fe9c7.svg";
export { ForwardRef as ReactComponent };